/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.describeServer'

export { $nsid }

/** Describes the server's account creation requirements and capabilities. Implemented by PDS. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    inviteCodeRequired: l.optional(l.boolean()),
    phoneVerificationRequired: l.optional(l.boolean()),
    availableUserDomains: l.array(l.string()),
    links: l.optional(l.ref<Links>((() => links) as any)),
    contact: l.optional(l.ref<Contact>((() => contact) as any)),
    did: l.string({ format: 'did' }),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Links = {
  $type?: 'com.atproto.server.describeServer#links'
  privacyPolicy?: l.UriString
  termsOfService?: l.UriString
}

export type { Links }

const links = l.typedObject<Links>(
  $nsid,
  'links',
  l.object({
    privacyPolicy: l.optional(l.string({ format: 'uri' })),
    termsOfService: l.optional(l.string({ format: 'uri' })),
  }),
)

export { links }

type Contact = {
  $type?: 'com.atproto.server.describeServer#contact'
  email?: string
}

export type { Contact }

const contact = l.typedObject<Contact>(
  $nsid,
  'contact',
  l.object({ email: l.optional(l.string()) }),
)

export { contact }
